interface CsvDownloadProps {
  data: any[];
  filename?: string;
  delimiter?: string;
}

export const csvGenerateRow = (row: any, delimiter: string) =>
  Object.values(row)
    .map((value) => (typeof value === "number" ? value : `"${String(value).replace(/"/g, '""')}"`))
    .join(delimiter);

export const csvGenerate = (data: any[], delimiter: string) =>
  data.map((row) => csvGenerateRow(row, delimiter)).join("\r\n");

const triggerCsvDownload = (csvAsString: string, fileName: string) => {
  const byteOrderMark = "\uFEFF";
  const blob = new Blob([byteOrderMark, csvAsString], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.style.display = "none";
  document.body.append(link);
  link.click();
  link.remove();
};

const csvDownload = ({ data, filename = "export.csv", delimiter = ";" }: CsvDownloadProps): void => {
  const formattedFilename = filename;

  if (data.length === 0) {
    triggerCsvDownload("", formattedFilename);
    return;
  }

  const csvAsString = csvGenerate(data, delimiter);

  triggerCsvDownload(csvAsString, formattedFilename);
};

export default csvDownload;
